{
  "schemaVersion": 2,
  "id": "ActorAtlasV2",
  "description": "The fixed Cinderwake actor rig. Every hero and monster supplies the same identity, direction, action, and reaction source families; the offline builder deterministically normalizes them into fixed, untrimmed atlas cells.",
  "source": {
    "pixelWidth": 1024,
    "pixelHeight": 1024,
    "columns": 4,
    "rows": 4,
    "cellWidth": 256,
    "cellHeight": 256,
    "background": "#ff00ff",
    "files": {
      "primary": "{actor}-source.png",
      "directions": "{actor}-directions-source.png",
      "actions": "{actor}-actions-source.png",
      "reactions": "{actor}-reactions-source.png",
      "directionActions": "{actor}-direction-actions-source.png",
      "directionReactions": "{actor}-direction-reactions-source.png"
    },
    "primaryRows": { "idle": 0, "walk": 1, "attack": 2, "ability": 3 },
    "directionRows": {
      "northIdle": 0,
      "northWalk": 1,
      "southIdle": 2,
      "southWalk": 3
    },
    "reactionRows": {
      "hurt": 0,
      "deathStart": 1,
      "deathEnd": 2,
      "groundedReserve": 3
    },
    "actionLayout": {
      "attackMotionCells": [0, 1, 2, 3, 4],
      "attackReviewReserveCell": 5,
      "recoveryReserveCells": [6, 7],
      "abilityCells": [8, 9, 10, 11, 12, 13, 14, 15],
      "runtimeAttackTerminal": { "source": "primary", "cell": 0 }
    },
    "directionActionRows": {
      "northAttack": 0,
      "northAbility": 1,
      "southAttack": 2,
      "southAbility": 3
    },
    "directionReactionRows": {
      "northHurt": 0,
      "northDeath": 1,
      "southHurt": 2,
      "southDeath": 3
    }
  },
  "atlas": {
    "pixelWidth": 1024,
    "pixelHeight": 2560,
    "columns": 8,
    "rows": 20,
    "cellWidth": 128,
    "cellHeight": 128,
    "footAnchor": { "x": 64, "y": 116 },
    "safeInkBounds": { "x": 5, "y": 4, "width": 118, "height": 112 },
    "reservedRows": [18, 19]
  },
  "clips": {
    "idle": {
      "atlasRow": 0,
      "frameCount": 6,
      "durationTicks": 60,
      "looping": true,
      "source": "primary",
      "sourceFrames": [0, 1, 2, 3, 2, 1]
    },
    "walk": {
      "atlasRow": 1,
      "frameCount": 8,
      "durationTicks": 40,
      "looping": true,
      "source": "primary",
      "sourceFrames": [4, 5, 6, 7, 4, 5, 6, 7]
    },
    "attack": {
      "atlasRow": 2,
      "frameCount": 6,
      "durationTicks": 26,
      "looping": false,
      "source": "actions",
      "sourceFrames": [0, 1, 2, 3, 4, { "source": "primary", "cell": 0 }]
    },
    "ability": {
      "atlasRow": 3,
      "frameCount": 8,
      "durationTicks": 36,
      "looping": false,
      "source": "actions",
      "sourceFrames": [
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        { "source": "primary", "cell": 0 }
      ]
    },
    "hurt": {
      "atlasRow": 4,
      "frameCount": 4,
      "durationTicks": 12,
      "looping": false,
      "source": "reactions",
      "sourceFrames": [0, 1, 2, { "source": "primary", "cell": 0 }],
      "authored": "articulated-recoil"
    },
    "death": {
      "atlasRow": 5,
      "frameCount": 8,
      "durationTicks": 48,
      "looping": false,
      "source": "reactions",
      "sourceFrames": [4, 5, 6, 7, 8, 9, 10, 11],
      "authored": "anatomy-specific-grounded-collapse"
    }
  },
  "directionalClips": {
    "northIdle": {
      "atlasRow": 6,
      "runtimeClip": "idle",
      "source": "directions",
      "sourceFrames": [0, 1, 2, 3, 2, 1]
    },
    "northWalk": {
      "atlasRow": 7,
      "runtimeClip": "walk",
      "source": "directions",
      "sourceFrames": [4, 5, 6, 7, 4, 5, 6, 7]
    },
    "southIdle": {
      "atlasRow": 8,
      "runtimeClip": "idle",
      "source": "directions",
      "sourceFrames": [8, 9, 10, 11, 10, 9]
    },
    "southWalk": {
      "atlasRow": 9,
      "runtimeClip": "walk",
      "source": "directions",
      "sourceFrames": [12, 13, 14, 15, 12, 13, 14, 15]
    },
    "northAttack": {
      "atlasRow": 10,
      "runtimeClip": "attack",
      "source": "directionActions",
      "sourceFrames": [0, 1, 2, 2, 3, { "source": "directions", "cell": 0 }]
    },
    "northAbility": {
      "atlasRow": 11,
      "runtimeClip": "ability",
      "source": "directionActions",
      "sourceFrames": [
        4,
        5,
        6,
        6,
        7,
        7,
        7,
        { "source": "directions", "cell": 0 }
      ]
    },
    "northHurt": {
      "atlasRow": 12,
      "runtimeClip": "hurt",
      "source": "directionReactions",
      "sourceFrames": [0, 1, 2, { "source": "directions", "cell": 0 }]
    },
    "northDeath": {
      "atlasRow": 13,
      "runtimeClip": "death",
      "source": "directionReactions",
      "sourceFrames": [4, 4, 5, 5, 6, 6, 7, 7]
    },
    "southAttack": {
      "atlasRow": 14,
      "runtimeClip": "attack",
      "source": "directionActions",
      "sourceFrames": [8, 9, 10, 10, 11, { "source": "directions", "cell": 8 }]
    },
    "southAbility": {
      "atlasRow": 15,
      "runtimeClip": "ability",
      "source": "directionActions",
      "sourceFrames": [
        12,
        13,
        14,
        14,
        15,
        15,
        15,
        { "source": "directions", "cell": 8 }
      ]
    },
    "southHurt": {
      "atlasRow": 16,
      "runtimeClip": "hurt",
      "source": "directionReactions",
      "sourceFrames": [8, 9, 10, { "source": "directions", "cell": 8 }]
    },
    "southDeath": {
      "atlasRow": 17,
      "runtimeClip": "death",
      "source": "directionReactions",
      "sourceFrames": [12, 12, 13, 13, 14, 14, 15, 15]
    }
  },
  "actorOverrides": {
    "arcanist": {
      "clips": {
        "walk": {
          "frameTransform": {
            "scaleX": 1,
            "scaleY": 1.23,
            "anchor": "foot"
          },
          "reason": "Normalize the undersized side-on walk bank to the idle body-height envelope while preserving the authored stride and fixed foot contact."
        }
      },
      "transitionContracts": {
        "eastWestIdleWalk": {
          "clips": ["idle", "walk"],
          "facings": ["east", "west"],
          "anchor": "foot",
          "maximumAtlasMedianInkHeightDifference": 8,
          "reason": "The character must not visibly shrink when side-on input starts; this atlas-level contract is stricter than the 8 logical-pixel rendered-sequence limit."
        }
      }
    },
    "ashfang": {
      "clips": {
        "walk": {
          "frameTransform": {
            "scaleX": 0.9,
            "scaleY": 1.17,
            "anchor": "foot"
          },
          "reason": "Keep the low side-on run within the idle body-height envelope without the former vertical stretch, while preserving cadence, source identity, and fixed foot contact."
        },
        "ability": {
          "sourceFrames": [
            8,
            9,
            9,
            11,
            12,
            13,
            14,
            { "source": "primary", "cell": 0 }
          ],
          "reason": "Hold the charged crouch for one frame and omit the disconnected airborne pose before the ground strike."
        }
      },
      "transitionContracts": {
        "eastWestIdleWalk": {
          "clips": ["idle", "walk"],
          "facings": ["east", "west"],
          "anchor": "foot",
          "maximumAtlasMedianInkHeightDifference": 8,
          "reason": "The quadruped must not visibly grow when locomotion begins; this atlas-level contract is stricter than the 8 logical-pixel rendered-sequence limit."
        }
      }
    }
  },
  "facing": {
    "east": "primary-bank",
    "west": "primary-bank-horizontal-flip",
    "north": "authored-north-bank",
    "south": "authored-south-bank",
    "actionFallback": "none-all-cardinal-banks-authored"
  }
}
